import { Pipe, PipeTransform } from '@angular/core';
import { formatGermanNumber } from '../../../shared/pipes/german-number-pipe';
import { SupplierContractPriceRange } from '../stores/supplier-contracts.store';

@Pipe({
  name: 'priceRange',
})
export class SupplierContractPriceRangePipe implements PipeTransform {
  /**
   * @param priceRange An object containing the minimum and maximum price in cents. If the minimum and maximum price are the same, only one price will be shown. Otherwise, a price range will be shown.
   * @param unit The unit of the price. If 'EURO', the price will be divided by 100 and formatted as euros. If 'CENTS', the price will be formatted as cents. Default is 'EURO'.
   * @param fixed Number of digits after the decimal point. Must be in the range 0 - 20, inclusive. If set to -1, the price will not be formatted and all digits will be shown. Default is 2.
   * @returns A formatted price string. If the minimum and maximum price are the same, only one price will be shown. Otherwise, a price range will be shown.
   */
  transform(
    priceRange: SupplierContractPriceRange,
    unit: 'EURO' | 'CENTS' = 'EURO',
    fixed = 2,
  ): string | null {
    if (priceRange.min === priceRange.max) {
      return `${this.formatPrice(priceRange.min, unit, fixed)}`;
    }
    return `${this.formatPrice(priceRange.min, unit, fixed)} - ${this.formatPrice(priceRange.max, unit, fixed)}`;
  }

  private formatPrice(price: number, unit: 'EURO' | 'CENTS', fixed: number) {
    const unitPrice = price / (unit === 'EURO' ? 100 : 1);
    return formatGermanNumber(unitPrice, fixed);
  }
}
